import { api } from '@/shared/api'
import { VkOrdAgencyAct, VkOrdAgencyContract } from '@synapex/prisma/client'
import { WorkspaceDescriptor } from '@synapex/shared2/entities'
import {
    CreateVkOrdAgencyActDto,
    CreateVkOrdAgencyContractDto,
    UpdateVkOrdAgencyActDto,
    UpdateVkOrdAgencyContractDto,
    VkOrdAgencyContractResponse,
    VkOrdCreativeResponseWithCreative,
    WorkspaceActIdDto,
} from '@synapex/shared2/gateway-rest-api'
import { workspacePath } from '@synapex/shared2/gateway-rest-api'
import { CamelIdObj } from '@synapex/tools/typescript'
import { pickDto } from '../utils'

export const getAgencyContracts = (wd: WorkspaceDescriptor) => {
    return api.get<VkOrdAgencyContractResponse[]>(
        `/ord/${workspacePath(wd)}/agency-contracts`
    )
}

export const createAgencyContract = (
    wd: WorkspaceDescriptor,
    dto: CreateVkOrdAgencyContractDto
) => {
    return api.put<VkOrdAgencyContract>(
        `/ord/${workspacePath(wd)}/agency-contracts`,
        pickDto(CreateVkOrdAgencyContractDto, dto)
    )
}

export const updateAgencyContract = (
    { contractId, ...wd }: WorkspaceDescriptor & CamelIdObj<'contract'>,
    dto: UpdateVkOrdAgencyContractDto
) => {
    return api.put<VkOrdAgencyContract>(
        `/ord/${workspacePath(wd)}/agency-contracts/${contractId}`,
        pickDto(UpdateVkOrdAgencyContractDto, dto)
    )
}

export const deleteAgencyContract = ({
    contractId,
}: {
    contractId: number
}) => {
    return api.delete(`/ord/agency-contracts/${contractId}`)
}

export const createAgencyAct = (
    wd: WorkspaceDescriptor,
    dto: CreateVkOrdAgencyActDto
) => {
    return api.put<VkOrdAgencyAct>(
        `/ord/${workspacePath(wd)}/agency-acts`,
        pickDto(CreateVkOrdAgencyActDto, dto)
    )
}

export const updateAgencyAct = (
    { actId, ...wd }: WorkspaceActIdDto,
    dto: UpdateVkOrdAgencyActDto
) => {
    return api.put<VkOrdAgencyAct>(
        `/ord/${workspacePath(wd)}/agency-acts/${actId}`,
        pickDto(UpdateVkOrdAgencyActDto, dto)
    )
}

export const deleteAgencyAct = ({ actId }: { actId: number }) => {
    return api.delete(`/ord/agency-acts/${actId}`)
}

export const getAgencyCreatives = (agencyContractId: number) => {
    return api.get<VkOrdCreativeResponseWithCreative[]>(
        `/ord/creatives/agency/${agencyContractId}`
    )
}
